var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"table"},[_vm._l((_vm.ranks),function(item){return _c('teamRankCell',{key:item.type,attrs:{"rankData":item}})}),_c('loadStateView',{attrs:{"state":_vm.netState,"refreshHandle":_vm.loadData}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }